import { Button, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnGroup, BtnToolbar } from '@dec/shared';
import { CheckCircleFill, Wallet2 } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { PaymentCard } from '../components/PaymentCard';

export const RecordPaymentSuccessPage = () => {
  // se recupera el identificador del pago
  const { id } = useParams();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const onCancel = () => {
    const url = '/';
    navigate(url);
  };

  return (
    <>
      <PageTitle title={t('common.label.payment')} icon={Wallet2} />

      <div className={`alert alert-success fw-bold`}>
        <div className="d-flex justify-content-start gap-4 mt-0">
          <div className="me-4">
            <CheckCircleFill size={45} />
          </div>
          <div>
            <div>
              <h3> {t(`payments.recordSuccess`)}</h3>
            </div>
            <div className="text-muted">{t(`payments.recordSuccessNotes`)}</div>
          </div>
        </div>
      </div>

      <PaymentCard id={id!} />

      <BtnToolbar>
        <BtnGroup>
          {' '}
          <></>{' '}
        </BtnGroup>
        <BtnGroup>
          <Button action={ButtonAction.close} variant="secondary" onClick={onCancel} />
        </BtnGroup>
      </BtnToolbar>
    </>
  );
};
